import { useEffect, useState } from "react";

import { useLoadMatterTypes } from "@smart/manage-gql-client-dom";

import { getFormMatterTypeName } from "./column-helpers";
import { GqlSubmissionSummary } from "../../types";

export const useSupplementalMatterTypes = (
  submissions: GqlSubmissionSummary[],
) => {
  const [supplimentalMatterTypesToLoad, setSupplimentalMatterTypesToLoad] =
    useState<{ lead: string[]; matter: string[] }>({
      lead: [],
      matter: [],
    });

  const leadMatterTypes = useLoadMatterTypes(
    { matterTypeIds: supplimentalMatterTypesToLoad.lead, type: "lead" },
    { skip: !supplimentalMatterTypesToLoad.lead.length },
  );
  const matterMatterTypes = useLoadMatterTypes(
    { matterTypeIds: supplimentalMatterTypesToLoad.matter, type: "matter" },
    { skip: !supplimentalMatterTypesToLoad.matter.length },
  );

  useEffect(() => {
    const leadMatterTypeIds = new Set<string>();
    const matterMatterTypeIds = new Set<string>();
    submissions.forEach((submission) => {
      if (!submission.matter) return;
      const formMatterType = getFormMatterTypeName(submission);
      if (formMatterType) return;
      if (submission.matter.isLead) {
        leadMatterTypeIds.add(submission.matter.matterTypeId);
      } else {
        matterMatterTypeIds.add(submission.matter.matterTypeId);
      }
    });
    if (leadMatterTypeIds.size > 0 || matterMatterTypeIds.size > 0) {
      setSupplimentalMatterTypesToLoad({
        lead: Array.from(leadMatterTypeIds),
        matter: Array.from(matterMatterTypeIds),
      });
    }
  }, [submissions]);

  return [
    ...(leadMatterTypes.result ?? []),
    ...(matterMatterTypes.result ?? []),
  ];
};
